import { getMobileDevicePlatform, PLATFORMS } from 'helper/device';

export type MobileDevicePropsType = {
	renderIOS?: () => any;
	renderAndroid?: () => any;
	renderElse?: () => any;
};

const MobileDevice = ({ renderIOS, renderAndroid, renderElse }: MobileDevicePropsType) => {
	if (getMobileDevicePlatform() === PLATFORMS.IOS && renderIOS) {
		return renderIOS();
	}

	if (getMobileDevicePlatform() === PLATFORMS.ANDROID && renderAndroid) {
		return renderAndroid();
	}

	if (renderElse) {
		return renderElse();
	}

	return null;
};

export default MobileDevice;
